<script>
    import { createEventDispatcher } from "svelte/internal";

    export let transparent = false;
    export let type;
    export let intent = "secondary";
    export let fw = false
    export let disabled = false;

    const dispatch = createEventDispatcher();
</script>


<button
    class={intent}
    class:transparent={transparent}
    class:filled={!transparent}
    class:has-icon={$$slots.icon}
    class:has-text={$$slots.default}
    class:full-width={fw}
    {disabled}
    on:click|stopPropagation={(e) => {dispatch("click", e)}}
    {type}
    >
    {#if $$slots.icon}
        <span class="icon">
            <slot name="icon"></slot>
        </span>
    {/if}
    {#if $$slots.default}
        <span class="text">
            <slot></slot>
        </span>    
    {/if}
</button>


<style>
    button {
        z-index: 1;
        background-color: transparent;
        border-radius: 9999rem;
        padding: 0.75rem;
        padding: 0.75rem;
        /* font-weight: 600; */
        position: relative;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.8);
        font-size: 1rem;
        line-height: 1rem;
    }

    button:active {
        background-color: transparent;
    }
    
    .filled.danger {
        color: white;
    }

    .transparent.danger {
        color: #DA4A2B;
    }

    .transparent.primary {
        color: hsl(108, 84%, 31%);
    }

    /* BUTTON BACKGROUND Default State*/

    button::after {
        content: "";
        position: absolute;
        z-index: -2;
        border-radius: 9999rem;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    
    .filled::after {
        transform: scaleX(1) scaleY(1) perspective(1px);
        transition: transform 200ms cubic-bezier(0.3, 0.1, 0.25, 1.4), background-color 200ms ease-out;
    }
    
    .filled::before {
        transform: scaleX(0.98) scaleY(0.98) perspective(1px);
    }
    
    .filled.secondary::after {
        background-color: #F5F2EF;
    }

    .filled.primary::after {
        background-color: #87C777;
    }

    .filled.danger::after {
        background-color: #DA4A2B;
    }

    .transparent::after {
        opacity: 0;
        background-color: rgba(0, 0, 0, 0.08);
        transform: scaleX(0.7) scaleY(0.7) perspective(1px);
        transition: transform 200ms cubic-bezier(0.3, 0.1, 0.25, 1.4), opacity 150ms ease-out;
    }
    
    .transparent::before {
        transform: scaleX(0.7) scaleY(0.7) perspective(1px);
    }

    /* BUTTON BACKGROUND Hover States */

    button:hover::after,
    button:focus-visible::after,
    button:hover::before, 
    button:focus-visible::before {
        border-radius: 20px;
        transform: scaleX(1) scaleY(1) perspective(1px);
    }

    .transparent:hover::after,
    .transparent:active::after,
    .transparent:focus-visible::after {
        opacity: 1;
    }

    .filled.secondary:hover::after,
    .filled.secondary:active::after,
    .filled.secondary:focus-visible::after {
        background-color: #ebe6e2;
    }

    .filled.primary:hover::after,
    .filled.primary:active::after,
    .filled.primary:focus-visible::after {
        background-color: #9cd38f;
        /* background-color: hsl(108, 42%, 62%); */
        background-color: hsl(108, 40%, 50%);
        background-color: #6BBE7D;
    }

    .filled.danger:hover::after,
    .filled.danger:active::after,
    .filled.danger:focus-visible::after {
        background-color: hsl(11, 95%, 41%);
    }

    button:focus-visible::after {
        outline: 2px solid #032B43;
        outline-offset: 2px;
    }

    /* ACTIVE */

    /* Scaling */

    button:active:not(:disabled)::before,
    button:active:not(:disabled)::after {
        transform: scaleX(1.04) scaleY(1.04) perspective(1px);
    }

    /* Shadows */
    button::before {
        content: "";
        position: absolute;
        z-index: -2;
        border-radius: 9999rem;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        transform: scaleX(1) scaleY(1) perspective(1px);
        transition: transform 200ms cubic-bezier(0.3, 0.1, 0.25, 1.4), opacity 150ms ease-out;
    }

    button:active:not(:disabled)::before {
        opacity: 1;
    }

    .transparent::before {
        box-shadow: 0 3px 10px rgba(3, 43, 67, 0.2); 
    }
    
    .filled.secondary::before {
        box-shadow: 0 3px 10px rgba(224, 214, 205, 0.4); 
    }

    .filled.primary::before {
        box-shadow: 0 3px 10px rgba(26, 168, 40, 0.4);
    }

    .filled.danger::before {
        box-shadow: 0 3px 10px rgba(255, 0, 0, 0.4);
    }
    
    /* ICONS */

    button.has-text {
        padding: 0.75rem 1.5rem;
    }

    .icon {
        display: inline-block;
        width: 1rem;
        height: 1rem;
    }

    .has-text.has-icon > .icon {
        margin-left: -0.3rem;
        margin-right: 0.2rem;
    }
    
    :global(button.has-icon svg) {
        width: 1rem !important;
        height: 1rem;
    }

    .full-width {
        width: 100%;
    }

    button:disabled,
    button:disabled>span {
        filter: grayscale(0.6) brightness(1.2);
        cursor: not-allowed;
    }

    button:disabled>* {
        opacity: 0.5;
    }
</style>